const NoStudiesCard = ({ width = "280px", height = "280px" }) => {
  return (
    <div
      className="rounded-lg flex items-center justify-center bg-[#809CFF] text-white"
      style={{
        width: width,
        height: height,
      }}
    >
      <h2 className="text-4xl font-bold text-center">
        No studies
        <br />
        found
      </h2>
    </div>
  )
}

export default NoStudiesCard
